import { render } from "./SaveButton.vue?vue&type=template&id=4eba1d94&scoped=true"
import script from "./SaveButton.vue?vue&type=script&lang=js"
export * from "./SaveButton.vue?vue&type=script&lang=js"

import "./SaveButton.vue?vue&type=style&index=0&id=4eba1d94&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eba1d94"]])

export default __exports__